import { writable } from 'svelte/store';

export type Theme = 'light' | 'dark' | 'auto';

export const theme = writable<Theme>('auto');
